import ObjectEntry from './ObjectEntry';

export default ObjectEntry;
